export const AUTH_LOGIN = 'auth/AUTH_LOGIN';
export const SET_TOKEN = 'auth/SET_TOKEN';
